import { BASE_URL } from "../../../utils/requestUtils";
import { RelationshipToPolicyOwner } from "../types";

export const submitInsuranceInfoForProcessing = (
  s3_urls: string[],
  relationship_to_insured: RelationshipToPolicyOwner,
  access_token: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/insurance_info/submit_insurance_info/`, {
    method: "POST",
    body: JSON.stringify({
      s3_urls,
      relationship_to_insured,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
  });

export const uploadInsuranceImageForProcessing = async (
  file_data: string,
  token: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/insurance_info/upload_insurance_card/`, {
    method: "POST",
    body: JSON.stringify({ file_data }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
